import { AppConfig } from "../helpers";

export const Currency = {
	LiberianDollar: 1,
	USD: 2,
}
export const Feed = {
	Static: 6,
	Live: 5,

	//Virtual
	VFL: 1,
	VHC: 2,
	VDR: 3,
	VTO: 4,
	VFLM: 7,
	VBL: 8,
	EPL: 9,

	Casino:10,
	SpinAndWin:13,

	Home: 6,
	Fixture: 10001,
	Slots:10002,
	ContactUs:10003,
	WorkWithUs:10004,
	Promos: 11,
	LuckyNumbers:15,
	Landing:1,
}

export const VirtualFeedIds = [1, 2, 3, 4, 7, 8, 9];

export const FeedNames = {
	Static: "sport",
	Live: "live",
	VFL: "virtual",

	Home: "sport",
	Fixture: "Fixture",
	Slots:"slots",
	Casino: "casino",
	Promos:"promos",
	LuckyNumbers:"lucky-numbers",
	Landing:"landing-page",

}

export const FeedChangeStatus = {
	Update: 0,
	Add: 1,
	Delete: 2,

}
export const daysFormatted = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

export const Days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"]
// export const calenderDays = [{name:"SUN" , id:1},{name:"MON" , id:2},{name:"TUE" , id:3},{name:"WED" , id:4},{name:"THU" , id:5},{name:"FRI" , id:6},{name:"SAT" , id:7}]

export const Status = {
	Success: 1,
	Warning: 2,
	Error: 3,
	TokenExpired: 4
}

export const Device = {
	Size1: 1,
	Size2: 2,
	Size3: 3,
	Size4: 4,
	Size5: 5,
	Size6: 6,
	Size7: 7,
}

export const Env = {
	PROD: "PROD",
	PRODV1: "PRODV1",
	DEV: "DEV",
	DEV_HTTPS: "DEV_HTTP",
	LOCAL: "LOCAL",
	UK: "UK",
}

export const JackpotLevel = {
	"Gold": 1,
	"Silver": 2,
	"Bronze": 3,
	"Bonus": 4,
	"DailyMega"	:5,
	"Web"	:6,
	"SingleGame":7
}

//export const ShowSignIn = true